import { html } from "lit";
import { getDummyText } from "../../utils";

const headlineLengths = [20, 40, 30, 50, 25, 35];
const copytextLengths = [80, 220, 40, 100, 300, 120];

export const sampleImage = html`<div data-same-height="image">
    <img
        src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/6/b/csm_TruPrint-Productfinder-Keyvisual_aea587c489.jpg"
        alt=""
    />
</div>`;
export const sampleVideo = html`<div data-same-height="image">
    <video
        src="https://ia600106.us.archive.org/25/items/archive-video-files/test.mp4"
        playsinline
        preload="metadata"
    />
</div>`;

export const Template = () => html`
    <style>
        .example-common-element {
            border: dotted black 1px;
            padding: 20px;
            margin-bottom: 30px;
        }
        .example-common-column {
            border: dotted black 1px;
            padding: 20px 0;
        }
    </style>
    <ux-iws-same-height>
        <div class="ux-row ux-u-mt-l">
            ${[0, 1, 2, 3, 4, 5].map(
                (n) => html` <div class="ux-col-6">
                    <div class="example-common-element" data-same-height="item">
                        ${n === 4 ? sampleImage : ""}
                        ${n === 5 ? sampleVideo : ""}
                        <div class="ux-text-headline ux-text-headline--big">
                            ${getDummyText(
                                headlineLengths[n % headlineLengths.length]
                            )}
                        </div>
                        <p data-same-height="text">
                            ${getDummyText(
                                copytextLengths[n % copytextLengths.length]
                            )}
                        </p>
                    </div>
                </div>`
            )}
        </div>
    </ux-iws-same-height>
`;

export const TemplateTabs = (args) => {
    const { anchorNav } = args;
    return html`
        <ux-tab-container ?anchor-navigation=${anchorNav}>
            <ux-tab name="Tab 1" tab-id="tab1"> ${Template()} </ux-tab>
            <ux-tab name="Tab 2" tab-id="tab2"> ${Template()} </ux-tab>
        </ux-tab-container>
    `;
};
